import { Box } from '@mui/joy';

const VerticalSpacer = () => {
  return <Box sx={{ display: 'flex', width: '1px', flex: 1 }} />;
};

export default VerticalSpacer;
